import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags } from "@fortawesome/free-solid-svg-icons";

const ChartBottomBar = ({ periods, setting, setSetting, onPeriodChange }) => {
  const toggleVolume = () => {
    setSetting((prev) => ({
      ...prev,
      chartOverlay: prev.chartOverlay === "on" ? "off" : "on",
    }));
  };
  const togglePriceLabels = () => {
    setSetting((prev) => ({ ...prev, enablePrice: !prev.enablePrice }));
  };

  return (
    <div className="flex items-center justify-between px-4 py-0 border-t border-gray-200 bg-white">
      <div className="flex items-center gap-1" id="chart-timeframe-guide">
        {periods.map((p) => {
          const active = setting?.periodID === p.id;
          return (
            <button
              type="button"
              key={p.id}
              onClick={() => onPeriodChange(p)}
              className={`px-3 h-8 rounded text-xs font-semibold transition-colors ${
                active
                  ? "bg-gray-800 text-white"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              {p.display}
            </button>
          );
        })}
      </div>

      {/* Client "Trade Screen Launch Polish", 5. Bottom chart controls: "Reduce
          the visual emphasis of the Volume and Price Labels controls. Display
          them as: `Volume Off` / `Price Labels Off`. Use medium weight for the
          control names and muted gray for `Off`. They should read as secondary
          chart settings rather than primary actions. Preserve the existing
          active state behavior when either control is turned on."

          OFF state: the control name drops from font-semibold to font-medium in
          the body grey, and the state word is the `secondary` grey token —
          `Volume` reads as the setting, `Off` as its current value, and neither
          reads as a button you are supposed to press. Sentence case replaces the
          shouted ON/OFF for the same reason.

          ON state: untouched. Same filled primaryColor pill, same white text,
          same toggle handlers — turning a control on still looks exactly as it
          did, which is the "existing active state behavior" the client kept. */}
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={toggleVolume}
          className={`flex items-center gap-2 px-3 h-8 text-xs rounded transition-all ${
            setting?.chartOverlay === "on"
              ? "font-semibold bg-primaryColor text-white border-primaryColor hover:shadow-md"
              : "text-gray-600 border-gray-300 hover:bg-gray-50"
          }`}
          title="Toggle volume"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <rect x="4" y="14" width="4" height="6" rx="0.5" />
            <rect x="10" y="10" width="4" height="10" rx="0.5" />
            <rect x="16" y="6" width="4" height="14" rx="0.5" />
          </svg>
          <span className="font-medium">Volume</span>
          <span
            className={
              setting?.chartOverlay === "on" ? "font-semibold" : "text-secondary"
            }
          >
            {setting?.chartOverlay === "on" ? "On" : "Off"}
          </span>
        </button>
        <div className="w-px h-5 bg-gray-300" aria-hidden="true" />
        <button
          type="button"
          onClick={togglePriceLabels}
          className={`flex items-center gap-2 px-3 h-8 text-xs rounded transition-all ${
            setting?.enablePrice
              ? "font-semibold bg-primaryColor text-white border-primaryColor hover:shadow-md"
              : "text-gray-600 border-gray-300 hover:bg-gray-50"
          }`}
          title="Toggle price labels"
        >
          <FontAwesomeIcon icon={faTags} className="w-4 h-4" />
          <span className="font-medium">Price Labels</span>
          <span
            className={
              setting?.enablePrice ? "font-semibold" : "text-secondary"
            }
          >
            {setting?.enablePrice ? "On" : "Off"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ChartBottomBar;
